// @flow

// Skipping test coverage for this component since it is not possible to unit test it correctly
/* eslint-disable ta-code-conventions/has-matching-storydoc, ta-code-conventions/has-matching-test */

import * as React from 'react';
import type { HeadPropertySet, MetaTag } from './types';

type Props = HeadPropertySet;

type State = {|
  isMounted: boolean,
|};

const currentHeadProperties: HeadPropertySet = {
  title: undefined,
  metaTags: [],
  canonicalUrl: undefined,
  openGraphInfo: undefined,
};

/** Simple dictionary to keep track of and avoid duplicated meta tags. */
const metaTagsCollected = {};

/**
 * This is a special component that application code can use to indicate values for certain specific document head properties
 * (e.g. title, meta description, etc - see above for the full list).  The supported properties are limited to begin with, with
 * the intention to only grow this as necessary.
 *
 * Run-time effects:
 * - When this is executed during SSR, the properties are collected in a "last wins" manner, and then passed to the Java template builder
 *   for inclusion on the final page.
 * - When executed client-side, properties that have user-visible effects (e.g. title) are simply
 *   set on the document directly.
 *
 *   TODO: under some circumstances, titles may make sense to keep in a stack, e.g. set new title when opening a modal,
 *   and then restore when closing it.  But it is not supported at the moment.  Tracked as WP-782
 */
class HeadProperties extends React.Component<Props, State> {
  static defaultProps = {
    title: undefined,
    metaTags: undefined,
    canonicalUrl: undefined,
    openGraphInfo: undefined,
  };

  static getCurrent() {
    return currentHeadProperties;
  }

  state = { isMounted: false };

  componentDidMount() {
    this.setState({ isMounted: true });
  }

  render() {
    if (this.state.isMounted) {
      /* eslint-disable no-restricted-globals */
      if (this.props.title) {
        document.title = this.props.title;
      }
    } else {
      /** title */
      currentHeadProperties.title = this.props.title || currentHeadProperties.title;

      /** meta tags */
      if (this.props.metaTags) {
        const currentTags: MetaTag[] = currentHeadProperties.metaTags || [];
        this.props.metaTags.forEach(tag => {
          const tagKey = JSON.stringify(tag);

          /** We prevent duplicated meta tags by keeping track of them in metaTagsCollected */
          if (!(tagKey in metaTagsCollected)) {
            metaTagsCollected[tagKey] = true;
            currentTags.push(tag);
            currentHeadProperties.metaTags = currentTags;
          }
        });
      }

      /** canonical url */
      currentHeadProperties.canonicalUrl =
        this.props.canonicalUrl || currentHeadProperties.canonicalUrl;

      /** og tags */
      currentHeadProperties.openGraphInfo =
        this.props.openGraphInfo || currentHeadProperties.openGraphInfo;
    }

    return null;
  }
}

export default HeadProperties;
